module.exports = __webpack_public_path__ + "img/main.a1fe467c.png";